// extracted by mini-css-extract-plugin
module.exports = {"KinoklubbTicket":"KinoklubbTicket_KinoklubbTicket__Lp0XB","Promo":"KinoklubbTicket_Promo__uk4Pt"};